var React = require('react');

function LaptopIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Layer_2","data-name":"Layer 2"},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},[React.createElement("path",{"d":"M665.88,35.44H86.7a5,5,0,0,0-5,5V347.66a5,5,0,0,0,5,5H665.88a5,5,0,0,0,5-5V40.44A5,5,0,0,0,665.88,35.44Zm-5,307.22H91.7V45.44H660.88Z","key":0}),React.createElement("path",{"d":"M740.7,450.66a4.45,4.45,0,0,0-.08-.81v-.13a4.63,4.63,0,0,0-.25-.8l-.09-.22a.64.64,0,0,0-.1-.23L704.3,378.92V5a5,5,0,0,0-5-5H53.3a5,5,0,0,0-5,5V378.59L.82,447.94h0a.35.35,0,0,0,0,.08,4.32,4.32,0,0,0-.36.67,2.44,2.44,0,0,0-.1.24,4.48,4.48,0,0,0-.22.71v.13a4.31,4.31,0,0,0-.09.88V477a5,5,0,0,0,5,5H735.7a5,5,0,0,0,5-5V450.66ZM58.31,10h636V375.13h-636ZM56,385.11H696.22l31.28,60.64H14.44ZM730.7,472H10V455.77H730.7Z","key":1})])));
}

LaptopIcon.defaultProps = {"viewBox":"0 0 740.7 482"};

module.exports = LaptopIcon;

LaptopIcon.default = LaptopIcon;
